import { call, put, takeEvery } from "redux-saga/effects"

// Meal Redux States
import {
  GET_COUNTRIES,
  GET_STATES,
  GET_CITIES,
  GET_AVAILABLE_TYPES,
  GET_AVAILABILITIES,
  GET_MEETING_START_URL,
} from "./actionTypes"
import {
  getCountriesSuccess,
  getCountriesFail,
  getStatesSuccess,
  getStatesFail,
  getCitiesSuccess,
  getCitiesFail,
  getAvailableTypesSuccess,
  getAvailableTypesFail,
  getAvailabilitiesSuccess,
  getAvailabilitiesFail,
  getMeetingStartURLSuccess,
  getMeetingStartURLFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getCountries,
  getStates,
  getCities,
  getAvailabilities,
  getMeetingStartURL,
} from "helpers/backend_helper"

// toast
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

function* fetchCountries() {
  try {
    const response = yield call(getCountries)
    yield put(getCountriesSuccess(response))
  } catch (error) {
    yield put(getCountriesFail(error))
  }
}

function* fetchStates({ payload: countryID }) {
  try {
    const response = yield call(getStates, countryID)
    yield put(getStatesSuccess(response))
  } catch (error) {
    yield put(getStatesFail(error))
  }
}

function* fetchCities({ payload: stateID }) {
  try {
    const response = yield call(getCities, stateID)
    yield put(getCitiesSuccess(response))
  } catch (error) {
    yield put(getCitiesFail(error))
  }
}

function* fetchAvailableTypes() {
  try {
    const response = yield call(getAvailableTypes)
    yield put(getAvailableTypesSuccess(response))
  } catch (error) {
    yield put(getAvailableTypesFail(error))
  }
}

function* fetchAvailabilities() {
  try {
    const response = yield call(getAvailabilities)
    yield put(getAvailabilitiesSuccess(response))
  } catch (error) {
    yield put(getAvailabilitiesFail(error))
  }
}

function* fetchMeetingStartURL({ payload: meetingKey }) {
  try {
    const response = yield call(getMeetingStartURL, meetingKey)
    yield put(getMeetingStartURLSuccess(response))
  } catch (error) {
    yield put(getMeetingStartURLFail(error))
  }
}

function* helperSaga() {
  yield takeEvery(GET_COUNTRIES, fetchCountries)
  yield takeEvery(GET_STATES, fetchStates)
  yield takeEvery(GET_CITIES, fetchCities)
  yield takeEvery(GET_AVAILABLE_TYPES, fetchAvailableTypes)
  yield takeEvery(GET_AVAILABILITIES, fetchAvailabilities)
  yield takeEvery(GET_MEETING_START_URL, fetchMeetingStartURL)
}

export default helperSaga
